import React from 'react';

import { Text } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import { Box, BoxProps } from 'components/ui';

type HeaderContainerProps = BoxProps & {
  backgroundColor?: string;
};

export const Container = ({ style, ...props }: BoxProps) => (
  <Box {...props} style={[styles.container, style]} />
);

export const ProductTitle = Text.withConfig({
  variant: 'headerTwo',
  margin: 0,
  numberOfLines: 1,
});

export const ProductDetailFlowHeaderContainer = ({
  backgroundColor,
  style,
  ...props
}: HeaderContainerProps) => (
  <Box {...props} style={[styles.productDetailFlowHeaderContainer, { backgroundColor }, style]} />
);

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 64,
    width: '100%',
  },
  productDetailFlowHeaderContainer: {
    alignItems: 'center',
    height: 64,
    justifyContent: 'center',
    width: '100%',
  },
});
